import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'roo-ui/components';
import convertPayWithQueryParams from 'lib/search/convertPayWithQueryParams';
import usePointsConverters from 'hooks/points/usePointsConverters';

const PayWithButtonGroup = ({ payWith, minPrice, maxPrice, updateQuery, options, name, ...rest }) => {
  const { convertCashToPoints, convertPointsToCash } = usePointsConverters();

  const onChange = useCallback(
    (payWith) => {
      updateQuery(convertPayWithQueryParams({ convertCashToPoints, convertPointsToCash, payWith, minPrice, maxPrice }));
    },
    [convertCashToPoints, convertPointsToCash, maxPrice, minPrice, updateQuery],
  );

  return (
    <form>
      <ButtonGroup value={payWith} onChange={onChange} options={options} name={name} {...rest} />
    </form>
  );
};

PayWithButtonGroup.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  payWith: PropTypes.string.isRequired,
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  updateQuery: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
};

PayWithButtonGroup.defaultProps = {
  name: 'payWith',
  isDisabled: false,
  size: 'base',
  minPrice: undefined,
  maxPrice: undefined,
};

export default PayWithButtonGroup;
